import React, {ReactNode} from 'react';
import {GridProps, Grid} from '@mui/material';

type PageHeaderTitleProps = Partial<GridProps> & {
  title: string;
  label: string;
  Icon: ReactNode;
  IconNextToTitle?: boolean;
};

const PageHeaderTitle: React.FC<PageHeaderTitleProps> = ({title, label, Icon, IconNextToTitle = false}) => {
  return (
    <Grid container direction="row" alignItems="center">
      <Grid>
        <h1>
          {title} {IconNextToTitle && Icon}
        </h1>
        <p>{label}</p>
      </Grid>
      {!IconNextToTitle && <Grid>{Icon}</Grid>}
    </Grid>
  );
};

export default PageHeaderTitle;
